import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, Row, Col, Select } from 'antd';
import 'antd/dist/antd.css';
import api from '../../../services/api';
import { escolaridadeService } from '../../../services/Escolaridade-Service/escolaridade-service';

interface ModalNovEscolaridadeProps {
    modalStatus?: any,
    setNovoOrgaoModal?: any,
    visivel: boolean,
    fecharModal: Function,
    atualizarConsulta:Function
}

const ModalNovaEscolaridade: React.FC<ModalNovEscolaridadeProps> = (prop) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;    

    useEffect(() => {
        form.resetFields();
    }, [prop.visivel, form])
  

    const onFinish = (values: any) => {
        setLoading(true)
        escolaridadeService.post(values)
            .finally(() => setLoading(false))
            .then((response) => {
                if (response.data.valido) {
                    message.success('Escolaridade salva com sucesso')                    
                    prop.fecharModal();
                    prop.atualizarConsulta();
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
            });
    };

    const onFinishFailed = (errorInfo: any) => {
    };

    return (
        <Modal visible={prop.visivel} title="Nova Escolaridade" onCancel={()=>prop.fecharModal()} footer={null}>
            <Form name="basic" form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item label="Descrição" name="descricao"
                            rules={[{ required: true, message: 'Por favor insira uma descrição!', }]}>
                            <Input placeholder="Digite a descrição da escolaridade" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item label="Estudando" name="estudando" initialValue={null}
                         rules={[{ required: true, message: 'Por favor selecione um valor!', }]}>                        
                            <Select placeholder="Selecione">
                                <Option value={null}>Selecione</Option> <Option value={true}>Sim</Option> <Option value={false}>Não</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button loading={loading} className="button-pre-cadastro" type="primary" htmlType="submit">
                        Finalizar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
}

export default ModalNovaEscolaridade

